module.exports = __webpack_public_path__ + "static/media/image0_thumb.84368dcf.jpeg";